import { Tab, Tabs } from 'react-bootstrap';

import DataReleaseHistoryNavigator from '@/modules/calendar/components/data/data-release-history-navigator';
import DeepDiveGraphList from '@/modules/calendar/components/data-deep-dive/deep-dive-graph-list';
import { DeepDiveAnalysisList } from '@/modules/calendar/components/data-deep-dive/deep-dive-analysis-list';

export default function DeepDiveLanding() {
  return (
    <div>
      <Tabs defaultActiveKey={'todays-events'}>
        <Tab title={"Today's Events"} eventKey={'todays-events'}>
          <DeepDiveGraphList />
        </Tab>
        <Tab title={'Data Browser'} eventKey={'data-browser'}>
          <div className={'mt-2'}>
            <DataReleaseHistoryNavigator />
          </div>
        </Tab>
        <Tab title={'Data Analysis'} eventKey={'data-analysis'}>
          <div className={'mt-2'}>
            <DeepDiveAnalysisList />
          </div>
        </Tab>
      </Tabs>
    </div>
  );
}
